// extracted by mini-css-extract-plugin
export default {"inactive":"r92g2cePBaQ5r2cFpbQr"};